export default {
  "content": "<path d=\"M.5 44c0-24.3 19.7-44 44-44s44 19.7 44 44-19.7 44-44 44S.5 68.3.5 44z\" fill=\"#000\" fill-opacity=\".03\"/><path d=\"M44.5 26c-9.92 0-18 8.08-18 18s8.08 18 18 18 18-8.08 18-18-8.08-18-18-18zm14 18c0 3.14-1.06 6.04-2.8 8.36L36.14 32.8c2.32-1.74 5.22-2.8 8.36-2.8 7.72 0 14 6.28 14 14zm-28 0c0-3.14 1.06-6.04 2.8-8.36L52.86 55.2c-2.32 1.74-5.22 2.8-8.36 2.8-7.72 0-14-6.28-14-14z\" fill=\"#000\" fill-opacity=\".3\"/>",
  "attrs": {
    "width": "89",
    "height": "88",
    "viewBox": "0 0 89 88",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};